import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { mockData, images } from '../utils/mock';

export const Transformation = () => {
  return (
    <section className="relative py-24 bg-gradient-to-b from-zinc-900 to-black">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl group">
              <img
                src={images.strategy}
                alt="Transformación"
                className="w-full h-[500px] object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            </div>
            
            {/* Decorative element */}
            <div className="absolute -top-6 -left-6 w-40 h-40 bg-orange-500/20 rounded-full blur-3xl"></div>
          </div>

          {/* Right: Content */}
          <div className="order-1 lg:order-2">
            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
              {mockData.transformation.title}
            </h2>
            <p className="text-xl text-white/80 mb-8 leading-relaxed">
              {mockData.transformation.intro}
            </p>

            <div className="space-y-4 mb-10">
              {mockData.transformation.benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 p-4 bg-black/40 border border-white/10 rounded-xl hover:border-orange-500/50 hover:bg-black/60 transition-all duration-300 group"
                >
                  <div className="flex-shrink-0">
                    <CheckCircle2 className="w-6 h-6 text-orange-500 group-hover:scale-110 transition-transform duration-300" />
                  </div>
                  <p className="text-lg text-white/90 group-hover:text-white transition-colors duration-300">
                    {benefit}
                  </p>
                </div>
              ))}
            </div>

            <div className="p-6 bg-gradient-to-r from-orange-500/20 to-transparent border-l-4 border-orange-500 rounded-r-lg">
              <p className="text-lg text-white/80 mb-2">
                {mockData.transformation.conclusion}
              </p>
              <p className="text-3xl text-white font-bold">
                {mockData.transformation.highlight}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
